"use client"

import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-7 w-14 shrink-0 cursor-pointer items-center rounded-full border border-gray-200 dark:border-gray-700 shadow-sm transition-all duration-300 ease-in-out",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-background",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:bg-gradient-to-r data-[state=checked]:from-blue-500 data-[state=checked]:to-indigo-600 data-[state=checked]:border-transparent",
      "data-[state=unchecked]:bg-gray-100 dark:data-[state=unchecked]:bg-gray-800",
      "hover:shadow-md hover:border-gray-300 dark:hover:border-gray-600",
      "data-[state=checked]:hover:from-blue-600 data-[state=checked]:hover:to-indigo-700",
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-5 w-5 rounded-full bg-white shadow-lg ring-0",
        "transition-all duration-300 ease-in-out",
        "data-[state=checked]:translate-x-7 data-[state=unchecked]:translate-x-1",
        "data-[state=checked]:shadow-xl data-[state=checked]:bg-white",
        "data-[state=unchecked]:shadow-md"
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
